import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EDealType, IDealTypeState } from 'shared/types/wantType';

const initialState: IDealTypeState = { value: EDealType.Sale };

/* istanbul ignore next */
const dealTypeSlice = createSlice({
  initialState,
  name: 'dealType',
  reducers: {
    setDealType: (state, action: PayloadAction<EDealType>) => {
      // eslint-disable-next-line no-param-reassign
      state.value = action.payload;
    },
  },
});

export const {
  reducer: dealTypeReducer,
  actions: { setDealType },
} = dealTypeSlice;
